import { render, staticRenderFns } from "./ShoppingBag.vue?vue&type=template&id=745c400e&"
import script from "./ShoppingBag.vue?vue&type=script&lang=js&"
export * from "./ShoppingBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports